<template>
  <div
    class="link-item"
    :class="{
      'has-icon': icon,
      'has-border': border
    }"
    @click="go"
  >
    <div class="left">
      <slot name="left"></slot>
    </div>
    <div class="right">
      <slot name="right"></slot>
    </div>
    <img src="@/assets/next.png" />
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: Boolean,
      default: true
    },
    border: {
      type: Boolean,
      default: true
    },
    href: {
      type: String
    },
    to: {
      type: String
    }
  },
  methods: {
    go() {
      if (this.to) {
        this.$router.push(this.to);
      } else if (this.href) {
        window.location.href = this.href;
      } else {
        this.$emit('click');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/px2rem.scss";

.link-item {
  display: flex;
  align-items: center;
  height: px2rem(148);
  padding: 0 px2rem(22) 0 px2rem(32);

  &.has-icon {
    img {
      display: inline-block;
    }
  }

  &.has-border {
    border-bottom: 1px solid #eee;
  }

  .left {
    flex: 1;
    font-size: px2rem(32);
  }

  .right {
    margin: 0;
    text-align: right;
    font-size: px2rem(28);
    color: #999;
  }

  img {
    display: none;
    width: px2rem(40);
    height: px2rem(40);
    margin-left: px2rem(10);
  }
}
</style>
